<template>
  <AbstractTransferProtocolModal
    :strategy="strategy"
    :transferProtocol="transferProtocolEntity"
    v-bind="$attrs"
    v-on="$listeners"
  ></AbstractTransferProtocolModal>
</template>

<script>
import AbstractTransferProtocolModal from '../abstract-transfer-protocol-modal';
import { CreateTransferProtocolByFleetStrategy } from './create-transfer-protocol-by-fleet.strategy';

export default {
  name: 'CreateTransferProtocolModalByFleet',
  components: {
    AbstractTransferProtocolModal,
  },
  props: {
    carEntity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    strategy() {
      return new CreateTransferProtocolByFleetStrategy(this.$store);
    },
    transferProtocolEntity() {
      // TODO: probably it would be better to extract this to class
      return {
        driverId: null,
        mileageReading: null,
        comments: null,
        equipment: [],
        transferDate: {
          date: null,
          time: null,
        },
        car: this.carEntity,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
